import { Button, FormControl, Grid, Group, IconButton, Layout, Page } from "@/comn/components";
import { useAuth, useFetch, useForm, useGrid, useModal, usePage, useResource, useStore, useToast } from "@/comn/hooks";
import { useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { APIS, URLS, SF_NOTI_LOGS_INFO } from "@/tra/tancis/ptli/ewc/svr/services/EwciNotiLogsService";

/*
 * Server detail information
 * !== 서버 상세 정보 ==!
 */
export const EWCI1001006Q = () => {
    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    const { pgeUid, menuId } = usePage();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { pgeStore, setStore, getStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast();
    const modal = useModal();
    const { notiSendUuid } = useParams(); // Key Information of this Component Router !== 라우터에 정의된 키정보 ==!

    useResource({
        defaultSchema: [{ area: "comnCd", comnCd: "CGM0176" }, { area: "comnCd", comnCd: "COM0024" },{ area: "comnCd", comnCd: "PTL0022" }],
    });

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        notiLogsInfo: useForm({
            defaultSchema: SF_NOTI_LOGS_INFO,
            defaultValues: {
                ...(pgeStore?.form || {}),
            },
        }),
    };

    const fetch = {
        // Gets UCR Reception management information. !== UCR 수관 관리 정보를 조회한다.==!
        getNotiLogsInfo: useFetch({
            api: () => {
                return APIS.getNotiLogsInfo(notiSendUuid);
            },
            onSuccess: (data) => {
                form.notiLogsInfo.setValues(data.logsDto.content);
            },
        }),
    };

    /*
     * Declaration Page Init Function
     * !== 화면 초기화 함수 선언  ==!
     */
    useEffect(() => {
        form.notiLogsInfo.setEditable(false);
        fetch.getNotiLogsInfo.fetch();
    }, []);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.notiLogsInfo.schema.notiId}></Group.Control>
                            <Group.Control {...form.notiLogsInfo.schema.bsopClsfCd}></Group.Control>
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.notiLogsInfo.schema.notiTpValue}></Group.Control>
                            <Group.Control {...form.notiLogsInfo.schema.notiSendStatCd}></Group.Control>
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.notiLogsInfo.schema.usrNm}></Group.Control>
                            <Group.Control {...form.notiLogsInfo.schema.sndrNm}></Group.Control>
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.notiLogsInfo.schema.usrEmlAddr}></Group.Control>
                            <Group.Control {...form.notiLogsInfo.schema.sndrEmlAddr}></Group.Control>
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.notiLogsInfo.schema.usrMoblNo}></Group.Control>
                            <Group.Control {...form.notiLogsInfo.schema.sndrTelno}></Group.Control>
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.notiLogsInfo.schema.notiNm}></Group.Control>
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.notiLogsInfo.schema.notiMsgCn}></Group.Control>
                        </Group.Row>
                    </Group.Section>
                </Group.Body>
            </Group>

            <Layout direction="row">
                <Layout.Left>
                    <Button
                        role="list"
                        onClick={() => {
                            navigate(URLS.ewci1001005q);
                        }}
                    ></Button>
                </Layout.Left>
            </Layout>
        </Page>
    );
};
